import type { IconData } from '@stacksjs/iconify-core'

export const chessPawnSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M14.5 11a9.5 9.5 0 1 1 19 0a9.5 9.5 0 0 1-19 0m15.904 10.15A11.94 11.94 0 0 1 24 23c-2.355 0-4.55-.678-6.404-1.85a186 186 0 0 0-1.207 4.733c-.8 3.322-1.667 7.326-2.282 11.291q.274-.023.547-.033c2.29-.076 5.396-.14 9.346-.14s7.056.064 9.346.14q.273.009.547.033c-.615-3.965-1.481-7.97-2.282-11.29a187 187 0 0 0-1.207-4.734M38.5 44.408c0 .33-.122.801-.297 1.183a2.2 2.2 0 0 1-.36.565c-.144.158-.381.344-.703.344H10.86c-.322 0-.559-.186-.703-.343a2.2 2.2 0 0 1-.36-.566c-.175-.382-.297-.852-.297-1.183c0-1.487.576-2.673 1.546-3.492c.958-.81 2.264-1.229 3.692-1.276c2.261-.076 5.34-.14 9.262-.14s7 .064 9.263.14c1.427.047 2.733.467 3.691 1.276c.97.819 1.546 2.005 1.546 3.492\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default chessPawnSolid
